import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';

const delivered_color = '#38C669';
const inprogress_color = '#F1C40F';
const failed_color = '#F76659';

const PieChart = ({ data }) => {
  const { delivered, failed, inprogress } = data;

  ChartJS.register(...registerables);
  const data1 = {
    labels: ["delivered", "failed", "in progress"], // ['Red', 'Blue', 'Yellow', 'Asghar'],
    datasets: [
      {
        data: [delivered, failed, inprogress], // [300, 50, 100, 40],
        backgroundColor: [delivered_color, failed_color, inprogress_color],
        hoverBackgroundColor: [delivered_color, failed_color, inprogress_color],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      title: {
        display: true,
        text: "Overall Delivery Rate",
      },
      legend: {
        position: 'bottom',
        defaultFontFamily: 'Poppins',
        align: 'center',
        labels: {
          usePointStyle: true,
          fontSize: 10,
          padding: 30,
        },
      }
    },
  };
  return <Pie data={data1} options={options} />;
};

export default PieChart;
